import React from "react";
import {
  Container,
  Jumbotron,
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
} from "reactstrap";
import businesspartner from "../business partner.jpg";
import IBM from "../IBM.jpg";
import automation from "../automation2.jpg";
import opensource2 from "../open source2.jpg";

const Example = (props) => {
  return (
    <div>
      <section id="header-section">
        <Jumbotron>
          <div className="text-container">
            <h1 className="title">At Business Values Services</h1>
            <p>
              We believe that your IT requirements should be supported by
              experienced professionals, and offer a variety of services to
              cater to your organization’s needs.
            </p>
            <p>
              We also believe values should be at the core of every business.
              They're what your business stands for, your philosophy, your
              reason for being. Your business's values will help to steer your
              business.
            </p>
            <a href="/">Call us today to find out more 🡢 </a>
          </div>
        </Jumbotron>
      </section>
      <section id="home-navigation-section">
        <Row className="navigation-panel justify-content-center">
          <Col md="2" className="navigation-item">
            <a href="#offer-section"> 🡣 What We Offer</a>
          </Col>
          <Col md="2" className="navigation-item">
            <a href="#mission-vision-section"> 🡣 Our Mission &amp; Vision</a>
          </Col>
          <Col md="2" className="navigation-item">
            <a href="#partner-section"> 🡣 IBM Partners</a>
          </Col>
          <Col md="2" className="navigation-item">
            <a href="#technologies-section"> 🡣 Business Potentials</a>
          </Col>
          <Col md="2" className="navigation-item">
            <a href="#technologies-section"> 🡣 Reach Us</a>
          </Col>
        </Row>
      </section>
      <section id="offer-section">
        <Container className="offer">
          <Row>
            <Col md="3" sm="12">
              <p className="text-left">What we offer </p>
            </Col>
            <Col md="9" sm="12">
              <p className="text-right">
                BVS provides a variety of innovative and comprehensive IT
                solutions. We deliver quality services in the most efficient
                way, and our experts will work collaboratively with you to
                customize our offerings to your particular needs. Book a meeting
                with one of our consultants to hear more about how we can assist
                your operation.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="mission-vision-section">
        <Container className="mission-vision">
          <Row>
            <Col md="6" sm="12">
              <h2 className="text-left">Our Vision</h2>
              <p>
                Becomes the number 1 implementer in the Middle East region for
                the Process, Portal and integration solutions.
              </p>
            </Col>
            <Col md="6" sm="12">
              <h2 className="text-left">Our Mission</h2>
              <p>
                Our mission is to be the leader in every field we serve, to the
                benefit of our customers, shareholders and all employees.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="partner-section">
        <Container className="partner">
          <Row>
            <Col md="6" sm="12">
              <div className="partner-image">
                <img src={businesspartner} alt="business partner"></img>
              </div>
            </Col>
            <Col md="6" sm="12">
              <h2 className="text-left">BVS AS IBM Partner</h2>
              <p>
                BVS is an official IBM partner certified to sell and service the
                following IBM domains:
              </p>
              <ul>
                <li>Analytics</li>
                <li>Enterprise Content Management</li>
                <li>Process Transformations</li>
                <li>System Middleware</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="technologies-section">
        <h3 className="tech-quote">Unlock the potential of your business</h3>
        <Container className="technologies">
          <Row>
            <Col md="4" sm="12">
              <h5 className="tech-title">IBM Products</h5>
              <Card>
                <CardImg width="100%" src={IBM} alt="Card image cap" />
                <CardBody>
                  <CardText className="text-left">
                    As Being IBM partner in MEA we have the best experts who are
                    capable to provide the best IBM services tailored to your
                    needs and also we can give you the best business and
                    technical consultancy for your planned ongoing growth plans.
                    Our variety of services include system administration,
                    product installation, business analysis, full cycle
                    architecture, implementation, testing till deployment and
                    support.
                  </CardText>
                  <a href="/">Find out more 🡢 </a>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" sm="12">
              <h5 className="tech-title">Open Source Technology</h5>
              <Card>
                <CardImg width="100%" src={opensource2} alt="Card image cap" />
                <CardBody>
                  <CardText className="text-middle">
                    In today’s hyperconnected world, organizations are
                    challenged in more ways than ever to stay ahead of the
                    curve. This implies being flexible to wide range of open
                    source front-end and backend suite of technologies to
                    support our customers in building evolving business
                    challenges. BVS is sure to help your organization succeed.
                  </CardText>
                  <a href="/">Find out more 🡢 </a>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" sm="12">
              <h5 className="tech-title">Business Automation</h5>
              <Card>
                <CardImg width="100%" src={automation} alt="Card image cap" />
                <CardBody>
                  <CardText className="text-right">
                    Automation of frequently repeated activities, covering not
                    only infrastructure but also company applications, allows
                    you to increase the flexibility of the company …while
                    maintaining economic efficiency. Automation simplifies and
                    accelerates customer contact and enables you to reach new
                    customers in a simpler and quicker way. Other benefits
                    including scale, leading to increased revenue and reduced
                    risk.
                  </CardText>
                  <a href="/">Find out more 🡢 </a>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="quote-section">
        <Container className="quote">
          <p>Join BVS Your Trusted Integrated Partner</p>
        </Container>
      </section>
      <section id="footer">
        <Container className="footer">
          <Row>
            <Col className="footer-links">
              <h6>Links</h6>
              <ul>
                <li>
                  <a href="/">Home 🡢 </a>
                </li>
                <li>
                  <a href="/">Partners 🡢 </a>
                </li>
                <li>
                  <a href="/">Our Frameworks 🡢 </a>
                </li>
                <li>
                  <a href="/">Added Business Value Solution 🡢 </a>
                </li>
              </ul>
            </Col>
            <Col className="footer-services">
              <h6>Services</h6>
              <ul>
                <li>
                  <a href="/">What we offer 🡢 </a>
                </li>
                <li>
                  <a href="/">Hybrid Integration 🡢 </a>
                </li>
                <li>
                  <a href="/">Digital Business Automation 🡢 </a>
                </li>
                <li>
                  <a href="/">B2B &amp; File Transfer Solutions 🡢 </a>
                </li>
                <li>
                  <a href="/">IBM Cloud Pak 🡢 </a>
                </li>
              </ul>
            </Col>
            <Col className="footer-quote">
              <h4>Reach us now for more details</h4>
              <p>
                <a href="mailto:contact-us@bvs-mea.com">Email 🡢</a>
              </p>
              <p>
                <a href="https://www.facebook.com/Business-Values-Service-110534167204178/?ref=bookmarks">
                  Facebook 🡢
                </a>
              </p>
              <p>
                <a href="https://www.linkedin.com/company/business-values-services-bvs-mea/">
                  LinkedIn 🡢
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Example;
